var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJardilandAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#D14800",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 16H28C21.3726 16 16 21.3726 16 28V44C16 50.6274 21.3726 56 28 56H44C50.6274 56 56 50.6274 56 44V28C56 21.3726 50.6274 16 44 16Z",
    fill: "#D14800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9949 46.6666C33.416 46.6666 32.1605 46.4538 31.2284 46.0281C30.7908 45.8539 30.6101 45.5153 30.6861 45.0122L31.1143 42.3709C31.2284 41.771 31.5232 41.5969 31.9988 41.8485C32.5315 42.1001 33.1212 42.2258 33.768 42.2258C34.4528 42.2258 34.9475 42.0323 35.2517 41.6453C35.5561 41.239 35.7084 40.5133 35.7084 39.4685V26.0879C35.7084 25.817 35.7655 25.6235 35.8796 25.5074C35.9937 25.3913 36.1839 25.3333 36.4503 25.3333H40.5879C40.8541 25.3333 41.0444 25.3913 41.1585 25.5074C41.2727 25.6235 41.3297 25.817 41.3297 26.0879V39.4103C41.3297 44.2478 39.2181 46.6666 34.9949 46.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJardilandAppIcon);
export default __webpack_public_path__ + "static/media/jardiland-app-icon.627fe7799023e3755119591a3ede01b5.svg";
export { ForwardRef as ReactComponent };